import { axiosInventoryInstance } from '@/config/apiConfig';
import axios, { AxiosResponse } from 'axios';
import {
  ICreateRole,
  IDeleteRole,
  IFetchRoles,
  IRole,
  IUpdateRole,
} from '@/services/role/role.type';
import { API_URL_CONFIG } from '@/config/urlConfig/apiUrlConfig';

// Define the User interface representing the structure of the user object returned by the API

export const fetchUserRoles = ({
  page,
  limit,
}: IFetchRoles): Promise<AxiosResponse<IRole[], any>> => {
  return axiosInventoryInstance({
    url: API_URL_CONFIG.USER.GET_ROLES,
    params: {
      page,
      limit,
    },
  });
};
export const fetchUserRole = (id: number): Promise<AxiosResponse<IRole>> => {
  return axiosInventoryInstance.get(`${API_URL_CONFIG.USER.GET_USER}/${id}`);
};

export const createUserRole = (
  payload: ICreateRole,
): Promise<AxiosResponse<IRole>> => {
  return axiosInventoryInstance.post(
    `${API_URL_CONFIG.USER.CREATE_USER}`,
    payload,
  );
};

export const updateUserRole = (
  id: string,
  payload: IUpdateRole,
): Promise<AxiosResponse<IRole>> => {
  const body = {
    roleName: payload?.roleName,
  };
  return axiosInventoryInstance.patch(
    `${API_URL_CONFIG.USER.CREATE_USER}/${id}`,
    { ...body },
  );
};

export const deleteUserRole = (
  id: IDeleteRole,
): Promise<AxiosResponse<IRole, any>> => {
  return axiosInventoryInstance.delete(
    `${API_URL_CONFIG.USER.CREATE_USER}/${id}`,
  );
};

export const getRoleNames = (
  roleIds: string[] | undefined,
  roleData: IRole[],
) => {
  const roleNames: string[] = [];
  const selectedRolesInfo: IRole[] = [];
  roleIds?.forEach((roleId: string) => {
    const role = roleData?.find((role: IRole) => role?.roleId === roleId);
    if (role) {
      roleNames.push(role?.roleName);
      selectedRolesInfo.push(role);
    }
  });
  const rolesDataInfo = {
    roleNameString: roleNames?.length ? roleNames.join(',') : '-',
    selectedRolesInfo,
    selectedRoleNamesArray: roleNames,
  };
  return rolesDataInfo;
};
